export default "__VITE_ASSET__xd2XO$Og__"